import React from 'react';
import { Loader } from "@progress/kendo-react-indicators";

const PlaceHolderBox = ({dataSource, loading}) => {
    return (
      <>
      { loading ?  
        <div className='place-holder'>
          <p>Loading {dataSource} Data</p>
          <Loader type={"infinite-spinner"} />
        </div> : 
        <div className='data-warning'>Unable to Retrieve {dataSource} User</div>
      }
      </>
    );
};

export default PlaceHolderBox;